import ConferencingService from './conferencing-service';
import ConferencingMarker from './conferencing-marker';

// The conferencing service operates in global scope and can destroy or spin up uScope instances. In order to do this it
// needs to be able to exist in global scope. Note that it shouldn't need to destroy uScope, but since that's a
// singleton, we're doing this for now...
let conferencingSingleton;

export default {
  createService (uScope) {
    if (!conferencingSingleton) {
      conferencingSingleton = new ConferencingService(uScope);
    } else {
      conferencingSingleton.setUScope(uScope);
    }

    // HACK ALERT - extend uScope with conferencing methods. Don't want to break existing implementations
    uScope.confCreate = conferencingSingleton.confCreate;
    uScope.isConfLeader = conferencingSingleton.isConfLeader;
    uScope.isModeConference = conferencingSingleton.isInConference;
    uScope.isConfMember = conferencingSingleton.isConfMember;

    // Note that this can be refactored to "extend" the viewport and simplify this nest a little
    uScope.events.on('uscope:image:init', (viewport) => {
      viewport.events.on('viewport:initialize-layout', () => {
        return new ConferencingMarker(viewport);
      });
    });

    return conferencingSingleton;
  }
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/conferencing/conferencing-factory.js